module.exports = __webpack_public_path__ + "static/media/chorthippus_biguttulus.dd1dfe05.jpg";